module.exports = __webpack_public_path__ + "static/media/numbermatka.94e9236a.png";